import axios from "axios";
import {serverBus} from "../main";

const baseUrl = process.env.VUE_APP_SKOLE_API_URL;


const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: true, // Check cross-site Access-Control
    headers: {
        Accept: 'application/json'
    },
});

instance.interceptors.request.use(
    function (config) {
        config.headers['role-id'] = localStorage.getItem('role_id');
        config.headers['organisation-id'] = localStorage.getItem('organisation_id');
        config.headers['organisation-type'] = localStorage.getItem('organisation_type');
        config.headers['school-year-id'] = localStorage.getItem('school_year_id');
        config.headers['school-id'] = localStorage.getItem('school_id');
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        const code = parseInt(error.response && error.response.status)
        if (code === 401) {
            window.location.href = `${baseUrl}sso/login?redirect_to=${location.href}`
        }else if (code===422){
            serverBus.$emit('show-snackbar', false, error.response.message);
        } else if (code ===400){
            serverBus.$emit('show-snackbar', false, error.response.message);
        }
        return Promise.reject(error);
    }
);

export default instance;
